import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useRoom } from "./RoomProvider";

/**
 * CinematicOverlay — the 400–800ms moments that make the room feel emotional.
 *
 * Assignment  → full-screen brand-teal flare that pulses once (draws the eye)
 * SOS         → room dims, single crimson pulse expands, no dialog
 *
 * These are room-level moments, not pinned to any coordinate. The map itself
 * signals location. This overlay signals *feeling*.
 */
export default function CinematicOverlay() {
  const { cinematic } = useRoom();

  return (
    <AnimatePresence>
      {cinematic?.kind === "assignment" && (
        <motion.div key="assign" className="cine cine-assign"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}>
          <motion.div className="cine-assign-flare"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: [0, 0.9, 0], scale: [0.8, 1.3, 1.9] }}
            transition={{ duration: 1.2, times: [0, 0.35, 1], ease: "easeOut" }} />
          <motion.div className="cine-assign-text"
            animate={{ opacity: [0, 1, 1, 0], y: [-4, 0, 0, -4] }}
            transition={{ duration: 1.2, times: [0, 0.2, 0.8, 1] }}>
            ASSIGNED
          </motion.div>
        </motion.div>
      )}

      {cinematic?.kind === "sos" && (
        <motion.div key="sos" className="cine cine-sos"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}>
          <motion.div className="cine-sos-dim"
            animate={{ opacity: [0, 0.75, 0.75, 0] }}
            transition={{ duration: 2.4, times: [0, 0.15, 0.85, 1] }} />
          <motion.div className="cine-sos-pulse"
            animate={{ scale: [1, 3.5], opacity: [0.9, 0] }}
            transition={{ duration: 2.4, repeat: 0 }} />
          <motion.div className="cine-sos-text"
            animate={{ opacity: [0, 1, 1, 0], y: [-10, 0, 0, -10] }}
            transition={{ duration: 2.4, times: [0, 0.15, 0.85, 1] }}>
            SOS · EVERYONE FEELS THIS
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
